"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Preview = function Preview(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "PreviewTitle PreviewDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "PreviewTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "PreviewDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M15.951 10.436a5.956 5.956 0 1 0 .009 11.91 5.956 5.956 0 0 0-.009-11.91zm0 10.8a4.844 4.844 0 1 1 .009-9.69 4.844 4.844 0 0 1-.009 9.69zm14.333-4.61a30.302 30.302 0 0 0-4.142-4.888c-3.39-3.227-6.915-4.93-10.19-4.93-3.276 0-6.8 1.703-10.188 4.93a30.476 30.476 0 0 0-4.146 4.889l-.21.324.228.307c.262.355 6.466 8.698 14.315 8.698 7.849 0 14.058-8.343 14.316-8.698l.226-.307-.209-.324zm-14.333 8.218c-6.467 0-12-6.435-13.178-7.933C3.93 15.267 9.44 7.938 15.951 7.938c6.511 0 12.022 7.329 13.182 8.973-1.195 1.498-6.715 7.933-13.182 7.933zm0-9.715a1.262 1.262 0 1 0 0 2.524 1.262 1.262 0 0 0 0-2.524z",
    id: "refPreviewVBD8CABogei"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refPreviewVBD8CABogei"
  }));
};

Preview.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Preview.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Preview;
exports["default"] = _default;